
export const menu = [
    {
        name:'Home',
        href:'/',
    },
    {
        name:'Elections',
        href:'/elections',
    },
    {
        name:'Nomination',
        href:'/nomination',
    },
    {
        name:'Voter Education',
        href:'/voter-education',
    },
    {
        name:'VvPat',
        href:'/vpat',
    },
]
export const menu2 = [
    {
        name:'Sign In',
        href:'/sign-in',
    },
    {
        name:'Sign Up',
        href:'/sign-up',
    },
]

export const candidates = [
    'Person A',
    'Person B',
    'Person C',
    'Person D',
    'Person E'
]

export const votingProcedures =[
    '1. Navigate to the elections tab',
    '2. Select your preffered candidate',
    '3. Confirm candidate selection',
    '4. OTP code will be sent to allow you finish voting',
    '5. Type the OTP code sent',
    '6. Congrats on voting. Keep the peace'

]

export const electionsCandidates = [
    {
        id:1,
        position:'Chairman',
        candidates:[
            {
                image:'https://images.unsplash.com/photo-1576363346069-e57aab1813bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YWZyaWNhbiUyMG1vZGVsc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person A',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1521038247815-3a29d8d1dc94?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YWZyaWNhbiUyMG1vZGVsc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person B',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1563132337-f159f484226c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person C',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1532332248682-206cc786359f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person D',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1613876215075-276fd62c89a4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person E',
                chosen:false,
            },
        ]
    },
    {
        id:2,
        position:'Delegate',
        candidates:[
            {
                image:'https://images.unsplash.com/photo-1576363346069-e57aab1813bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YWZyaWNhbiUyMG1vZGVsc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person A',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1521038247815-3a29d8d1dc94?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YWZyaWNhbiUyMG1vZGVsc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person B',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1563132337-f159f484226c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person C',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1532332248682-206cc786359f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person D',
                chosen:false,
            },
            {
                image:'https://images.unsplash.com/photo-1613876215075-276fd62c89a4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGFmcmljYW4lMjBtb2RlbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=400&q=60',
                name:'Person E',
                chosen:false,
            },
        ]
    }
]

export const candidateVotes =[
    {
        name:'Person A',
        Tvotes:60,
        refNo:'#545923458295'
    },
    {
        name:'Person B',
        Tvotes:54,
        refNo:'#aei9dafd3458'
    },
    {
        name:'Person C',
        Tvotes:49,
        refNo:'#er59234eraiig'
    },
    {
        name:'Person D',
        Tvotes:32,
        refNo:'#oip9234582er'
    },
    {
        name:'Person E',
        Tvotes:29,
        refNo:'#90eg23458295'
    },
]